import React, { useState, useEffect } from 'react';
import { getDashboarFirstCardsdData } from '../../api/Api';
import { useNavigate } from 'react-router-dom';

const TopCards = () => {
    const [dashboardData, setDashboardData] = useState([]);
    const navigate = useNavigate();
    const fetchDashboardData = async () => {
        try {
            const response = await getDashboarFirstCardsdData();
            if (response?.statusDescription?.status === 200) {
                setDashboardData(response.dashboard);
            }
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
        }
    };



    // Function to process dashboard data into stats format
    const processStatsData = () => {
        const stats = [];
        const groupedData = dashboardData.reduce((acc, item) => {
            if (!acc[item.dashboardId]) {
                acc[item.dashboardId] = [];
            }
            acc[item.dashboardId].push(item);
            return acc;
        }, {});

        Object.values(groupedData).forEach(group => {
            const baseItem = group[0];
            let trendText = '';
            let number = baseItem.dynamicCount;

            // Handle different cases based on dashboardId
            if (group.length > 1) {
                const categories = group.map(item =>
                    `<span class="${item.categoryColor}">${item.categoryText}: ${item.categoryCount}</span>`
                ).join(', ');
                trendText = categories;
                number = group.reduce((sum, item) => sum + item.categoryCount, 0);
            } else {
                number = baseItem.dynamicCount;
                trendText = baseItem.categoryText ?
                    `<span class="${baseItem.categoryColor}">${baseItem.categoryText}: ${baseItem.dynamicCount}</span>` :
                    `Total: ${baseItem.dynamicCount}`;
            }

            stats.push({
                id: baseItem.dashboardId,
                icon: baseItem.dashboardIcon,
                title: baseItem.dashboardTitle,
                number: number,
                trend: {
                    text: trendText,
                    isUp: true,
                    isHtml: true // Add this flag to indicate HTML content
                },
                color: baseItem.color,
                isCurrency: baseItem.dashboardTitle.includes('Revenue'),
                route: baseItem.route
            });
        });

        return stats;
    };
    // Function to format numbers
    const formatNumber = (number, isCurrency = false) => {
        if (isCurrency) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
            }).format(number);
        }
        return new Intl.NumberFormat('en-US').format(number);
    };
    const statsData = processStatsData();
    useEffect(() => {
        fetchDashboardData();
    }, []);
    // Handle card click
    const handleCardClick = (route) => {
        if (route) {
            navigate(route);
        }
    };
    return (
        <>
         <div className="card mb-3">
                <div className="p-3 p-md-4">
                    <div className="stats-container">
                        {statsData.map((stat) => (
                            <div
                                className="stat-card"
                                key={stat.id}
                                onClick={() => handleCardClick(stat.route)}
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                                    <i className={stat.icon}></i>
                                </div>
                                <div className="stat-details">
                                    <h3>{stat.title}</h3>
                                    <p className="stat-number">
                                        {stat.isCurrency ? formatNumber(stat.number, true) : formatNumber(stat.number)}
                                    </p>
                                    {stat.trend.isHtml ? (
                                        <span
                                            className={stat.trend.isUp ? "trend-up" : "trend-down"}
                                            dangerouslySetInnerHTML={{ __html: stat.trend.text }}
                                        />
                                    ) : (
                                        <span className={stat.trend.isUp ? "trend-up" : "trend-down"}>
                                            {stat.trend.text}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* <div className="card mb-3">
                <div className="container">
                    <div className="stats-container mt-4">
                        {statsData.map((stat) => (
                            <div
                                className="stat-card"
                                key={stat.id}
                                onClick={() => handleCardClick(stat.route)}
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <div className="stat-icon" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                                    <i className={stat.icon}></i>
                                </div>
                                <div className="stat-details">
                                    <h3>{stat.title}</h3>
                                    <p className="stat-number">
                                        {stat.isCurrency ? formatNumber(stat.number, true) : formatNumber(stat.number)}
                                    </p>
                                    {stat.trend.isHtml ? (
                                        <span
                                            className={stat.trend.isUp ? "trend-up" : "trend-down"}
                                            dangerouslySetInnerHTML={{ __html: stat.trend.text }}
                                        />
                                    ) : (
                                        <span className={stat.trend.isUp ? "trend-up" : "trend-down"}>
                                            {stat.trend.text}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default TopCards;
